import Vue from 'vue'
import Router from 'vue-router'

const Index = r => require.ensure([], () => r(require('../views/index.vue')))
const Detail = r => require.ensure([], () => r(require('../views/detail.vue')))

Vue.use(Router)

const router = new Router({
  mode: 'hash',

  routes: [
    {
      path: '/index',
      name: 'index',
      component: Index
    }, {
      path: '/detail',
      name: 'detail',
      component: Detail
    }, {
      path: '*',
      redirect: '/index'
    }
  ]
})

window.router = router

export default router
